import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchPreviousDestinations (personnelId) {
  return fetch(`/foreignTravel/personnel/${ personnelId }/destinationStats`)
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the previous destinations');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve previous destinations. Please reload the page and try again');
    });
}

const usePreviousDestinations = (personnelId) => {
  const value = useQuery({
    queryKey: ['usePreviousDestinations', personnelId],
    queryFn: () => fetchPreviousDestinations(personnelId),
    refetchOnWindowFocus: false,
    select: (response) => response.destinations,
    staleTime: Infinity,
    enabled: !!personnelId
  });

  return value;
};

export default usePreviousDestinations;
